import { useCallback, useContext } from "react";

import { useHistory } from "react-router-dom";

import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import { notify } from "../../../../utils/notify";
import { DespesasReembolsaveisContext } from "../contexts/DespesasReembolsaveisContext";
import { validNotNull } from "../../../../utils/validations";
import { findEmpresasV2 } from "../../../../repositories/qerpapi/erp/prouser/v2/EmpresasRepository";
import { findContratoServico } from "../../../../repositories/qerpapi/erp/faturamento/ContratoServicoRepository";
import {
  show as showDespesasReembolsaveis,
  store as despesasReembolsaveisStore,
  update as despesasReembolsaveisUpdate,
  destroy as destroyDespesasReembolsaveis,
} from "../../../../repositories/qerpapi/erp/faturamento/DespesasReembolsaveisRepository";

const useDespesasReembolsaveisController = () => {
  const {
    id,
    setId,
    companies,
    setCompanies,
    setLoading,
    description,
    setDescription,
    complement,
    setComplement,
    active,
    setActive,
    setErrorsSubmit,
    setDataTableReload,
    service,
    setService,
    setServiceList,
  } = useContext(DespesasReembolsaveisContext);

  const { queryParams } = useContext(QueryParamsContext);

  const { push } = useHistory();

  const handleCheckCompany = (companyId) => {
    const copyCheckCompanies = [...companies];
    const companyIndex = copyCheckCompanies.findIndex(
      (comp) => comp.id === companyId
    );

    copyCheckCompanies[companyIndex] = {
      ...copyCheckCompanies[companyIndex],
      check: !copyCheckCompanies[companyIndex].check,
    };

    if (!copyCheckCompanies.filter((e) => e.check).length)
      return notify("Ao menos uma empresa deve estar selecionada.");

    setCompanies(copyCheckCompanies);
  };

  const rulesToStore = (validate) => {
    if (!description) {
      validate.errorsValidation.description = true;
      validate.error = true;
    }

    return validate;
  };

  const storeAndUpdate = async (refresh = false) => {
    const jsonValidMain = [
      {
        key: "description",
        value: description,
      },
    ];

    const validateSubmit = rulesToStore(validNotNull(jsonValidMain));

    setErrorsSubmit({
      ...validateSubmit.errorsValidation,
    });

    if (validateSubmit.error)
      return notify(
        "Verifique se os campos foram preenchidos corretamente.",
        true,
        "warning"
      );

    try {
      setLoading(true);

      var callback;

      const body = {
        descricao: description,
        complemento: complement ?? null,
        ativo: active ? 1 : 0,
        servico: service?.id,
        usuario_id: queryParams?.usuario_id,
        cancelado: 0,
        empresas: [],
      };

      companies.forEach((company) => {
        if (company.check) body.empresas.push(company?.id);
      });

      if (id) {
        callback = await despesasReembolsaveisUpdate({
          empresa_cnpj: queryParams?.empresa_cnpj,
          id: id,
          body,
        });
      } else {
        callback = await despesasReembolsaveisStore({
          empresa_cnpj: queryParams?.empresa_cnpj,
          body,
        });
      }
      if (!refresh) push("listagem");
      clearContext();

      if (!callback.success)
        return notify("Erro ao salvar a despesa reembolsável.");
      else {
        return notify(
          `Despesa Reembolsável ${id ? "Atualizada" : "Cadastrada"}.`,
          true,
          "success"
        );
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const clearContext = useCallback(() => {
    setId(null);
    setDescription("");
    setCompanies((current) => current.map((e) => ({ ...e, check: true })));
    setErrorsSubmit({});
    setComplement("");
    setActive(true);
  }, [
    setId,
    setErrorsSubmit,
    setCompanies,
    setDescription,
    setComplement,
    setActive,
  ]);

  const destroy = async (id) => {
    try {
      setLoading(true);
      const callback = await destroyDespesasReembolsaveis({
        empresa_cnpj: queryParams?.empresa_cnpj,
        id: id,
        usuario_id: queryParams?.usuario_id,
      });

      if (!callback?.success)
        return notify("Erro ao excluir despesa reembolsável");
      else
        return notify(
          "Despesa reembolsável excluida com sucesso.",
          true,
          "success"
        );
    } catch (error) {
      console.error(error);
    } finally {
      setDataTableReload(true);
      setLoading(false);
    }
  };

  const handleSetData = useCallback(
    async (id) => {
      if (!queryParams?.empresa_cnpj) return;

      clearContext();

      try {
        setLoading(true);

        const [despesasReembolsaveis, companies, serviceList] =
          await Promise.all([
            showDespesasReembolsaveis({
              empresa_cnpj: queryParams?.empresa_cnpj,
              id: id ?? null,
            }),
            findEmpresasV2(queryParams?.empresa_cnpj),
            findContratoServico({ empresa_cnpj: queryParams?.empresa_cnpj, where: { ativo: "S", tiposervico: "A" } }),
          ]);

        if (
          !companies?.success ||
          !despesasReembolsaveis?.success ||
          !serviceList?.success
        )
          return notify("Erro ao buscar dados.");

        const checks = companies.data.map((companyExist) => {
          if (id) {
            return {
              ...companyExist,
              check: (despesasReembolsaveis?.data?.empresas || []).some(
                (comp) => comp?.id === companyExist?.id
              ),
            };
          } else
            return {
              ...companyExist,
              check: true,
            };
        });

        if (
          typeof despesasReembolsaveis.data === "object" &&
          !Array.isArray(despesasReembolsaveis.data) &&
          despesasReembolsaveis.data !== null
        ) {
          setDescription(despesasReembolsaveis.data?.descricao || "");
          setComplement(despesasReembolsaveis.data?.complemento || "");
          setActive(despesasReembolsaveis.data?.ativo === 1);
        }

        setCompanies(checks);
        const mappedServiceList = serviceList.data.map((item) => ({
          ...item,
          label: `${item.id} - ${item.descricao}`,
        }));
        setServiceList(
          mappedServiceList
        );
        setService(
          mappedServiceList.find(
            (item) => item.id === despesasReembolsaveis.data?.servico
          ) || null
        );
        setId(id ?? null);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    },
    [
      queryParams?.empresa_cnpj,
      setLoading,
      setDescription,
      setComplement,
      setActive,
      setCompanies,
      setServiceList,
      setService,
      clearContext,
      setId,
    ]
  );

  const back = () => {
    clearContext();
    push("listagem");
  };

  return {
    handleSetData,
    handleCheckCompany,
    destroy,
    back,
    clearContext,
    storeAndUpdate,
  };
};

export default useDespesasReembolsaveisController;
